import type {ReactElement} from 'react';
import {getAssetUrl} from '@Utils/s3.util';
import {PreviewAvatar} from '@Components/social-media/components/social-post-content-multiposting/components/preview-avatar/preview-avatar';
import {VerticalVideoAccountName} from '../vertical-video-account-name/vertical-video-account-name';
import {VerticalVideoCaptionLine} from '../vertical-video-caption-line/vertical-video-caption-line';
import {VerticalVideoScrim} from '../vertical-video-scrim/vertical-video-scrim';
import type {TiktokOverlayProps} from './tiktok-overlay.types';
import {TIKTOK_VIDEO_ACTION_ICON_PATHS, TIKTOK_VIDEO_FOLLOW_ICON_PATH} from './tiktok-overlay.types';
import styles from './tiktok-overlay.module.scss';

export function TiktokOverlay({account, caption}: TiktokOverlayProps): ReactElement {
  const getScrim = (): ReactElement => {
    return <VerticalVideoScrim className={styles.tiktokOverlayScrim} />;
  };

  const getCaptionBlock = (): ReactElement => {
    return (
      <div className={styles.tiktokOverlayCaptionBlock}>
        <VerticalVideoAccountName accountName={account.name} />
        <VerticalVideoCaptionLine caption={caption} moreClassName={styles.tiktokOverlayCaptionMore} />
      </div>
    );
  };

  const getActionRail = (): ReactElement => {
    return (
      <div className={styles.tiktokOverlayActionRail}>
        {getAvatarHolder()}
        {getActionIcons()}
      </div>
    );
  };

  const getAvatarHolder = (): ReactElement => {
    return (
      <div className={styles.tiktokOverlayAvatarHolder}>
        <PreviewAvatar account={account} className={styles.tiktokOverlayAvatar} />
        <img alt="" aria-hidden="true" className={styles.tiktokOverlayFollowBadge} src={getAssetUrl(TIKTOK_VIDEO_FOLLOW_ICON_PATH)} />
      </div>
    );
  };

  const getActionIcons = (): ReactElement[] => {
    return TIKTOK_VIDEO_ACTION_ICON_PATHS.map(
      (iconPath: string): ReactElement => (
        <span className={styles.tiktokOverlayActionSlot} key={iconPath}>
          <img alt="" aria-hidden="true" className={styles.tiktokOverlayActionIcon} src={getAssetUrl(iconPath)} />
        </span>
      )
    );
  };

  return (
    <>
      {getScrim()}
      {getCaptionBlock()}
      {getActionRail()}
    </>
  );
}
